import { Affiliation } from "./affiliation-model";
import { PaymentMethodType } from "./payment-method-type";

export class PaymentMethodMovement {
    paymentMethodDeduct: PaymentMethodType;
    paymentMethodDeductAmount: number;
    paymentMethodIncrease: PaymentMethodType;
    paymentMethodIncreaseAmount: number;

    constructor() {
        this.paymentMethodDeduct = new PaymentMethodType();
        this.paymentMethodDeductAmount = 0;
        this.paymentMethodIncrease = new PaymentMethodType();
        this.paymentMethodIncreaseAmount = 0;
    }
}